// extracted by mini-css-extract-plugin
module.exports = {"helpcenter":"ArticleSidebar_helpcenter__oJONc","agent-toolbar-open":"ArticleSidebar_agent-toolbar-open__buTFq","wrapper":"ArticleSidebar_wrapper__x3q5W"};